import { Modal } from 'bootstrap';

export default function initVideoModals(){
	// Create modal element if it doesn't exist
	if (!document.getElementById('youtube-video-modal')) {
		createYouTubeModal();
	}

	var links = document.querySelectorAll('a.external-link-ok');
	for(var i = 0; i < links.length; i++) {
		var link = links[i];
		var linkTarget = link.getAttribute("href");
		if(linkTarget != null){
			if(isYouTubeLink(linkTarget)){
				// Prevent default navigation for YouTube links
				link.addEventListener('click', function(e) {
					e.preventDefault();

					// Get YouTube video ID
					const videoId = getYouTubeVideoId(this.getAttribute("href"));
					if (videoId) {
						// Open YouTube video in modal
						openYouTubeModal(videoId);
					} else {
						// If video ID extraction fails, navigate to the original link
						window.open(this.getAttribute("href"), "_blank");
					}
				});
			}
		}
	}
};

/**
 * Check if the link is a YouTube link
 */
var isYouTubeLink = (linkTarget) => {
	const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/i;
	return youtubeRegex.test(linkTarget);
};

var getYouTubeVideoId = (url) => {
	try {
		const parsedUrl = new URL(url);
		const hostname = parsedUrl.hostname;
		const pathname = parsedUrl.pathname;
		const searchParams = new URLSearchParams(parsedUrl.search);

		// Handle youtu.be short links
		if (hostname.includes('youtu.be')) {
			const videoId = pathname.split('/')[1];
			return videoId ? videoId : null;
		}

		// Handle youtube.com and youtube-nocookie.com domains
		if (hostname.includes('youtube.com') || hostname.includes('youtube-nocookie.com')) {
			// Standard watch URLs with v parameter
			if (searchParams.has('v')) {
				return searchParams.get('v');
			}

			// Handle YouTube Shorts
			if (pathname.includes('/shorts/')) {
				const parts = pathname.split('/');
				const shortsIndex = parts.indexOf('shorts');
				if (shortsIndex !== -1 && parts.length > shortsIndex + 1) {
					return parts[shortsIndex + 1];
				}
			}

			// Handle embed URLs
			if (pathname.includes('/embed/')) {
				const parts = pathname.split('/');
				const embedIndex = parts.indexOf('embed');
				if (embedIndex !== -1 && parts.length > embedIndex + 1) {
					return parts[embedIndex + 1];
				}
			}
		}

		// If we get here, we couldn't extract a video ID
		console.warn('Could not extract YouTube video ID from URL:', url);
		return null;
	} catch (error) {
		console.error('Error extracting YouTube video ID:', error);
		return null;
	}
};

/**
 * Create YouTube modal in the DOM
 */
var createYouTubeModal = () => {
	const modalHTML = `
		<div class="modal fade" id="youtube-video-modal" tabindex="-1" aria-labelledby="youtubeVideoModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="ratio ratio-16x9">
							<iframe id="youtubeVideoFrame" src="" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						</div>
					</div>
				</div>
			</div>
		</div>
	`;

	document.body.insertAdjacentHTML('beforeend', modalHTML);
};

/**
 * Open YouTube modal with the specified video ID
 */
var openYouTubeModal = (videoId) => {
	const previouslyFocusedElement = document.activeElement;

	const iframe = document.getElementById('youtubeVideoFrame');
	iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

	const modalElement = document.getElementById('youtube-video-modal');
	modalElement.addEventListener('hide.bs.modal', function () {
		if (previouslyFocusedElement) {
			previouslyFocusedElement.focus();
		} else {
			document.body.focus();
		}
	}, { once: false });

	const modalInstance = new Modal(modalElement);
	modalInstance.show();

	// Reset iframe src when modal is hidden (stops video playback)
	modalElement.addEventListener('hidden.bs.modal', function () {
		iframe.src = '';
	}, { once: false });
};

